import buildJson from '@/config/build.json';
import { useAppSelector } from '@/state/hooks';
import { selectAppVersion } from '@/state/reducers/appVersionSlice';

const BuildVersion = () => {
    const { currentVersion } = useAppSelector(selectAppVersion);

    return (
        <div className="hidden sm:block justify-start">
            v{currentVersion} <span className="text-brand-neutral-400 text-xs">({buildJson.build})</span>
        </div>
    );
};

export default BuildVersion;
